export default __webpack_public_path__ + "static/media/ic-file.2b8518bb.svg";